<template>
  <v-menu
    bottom
    left
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :class="['pa-0', floatRight ? 'float-right' : '']"
        color="#EFEFEF"
        v-on="on"
      >
        <country-flag :country="flagFromCountryIso(locale)" />
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="lang in langs"
        :key="lang"
        @click="setLocale(lang)">
        <v-list-item-title>
          <country-flag :country="flagFromCountryIso(lang)"/>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import CountryFlag from 'vue-country-flag';

export default {
  name: 'LocaleChanger',

  components: { CountryFlag, },

  props: {
    floatRight: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data () {
    return { langs: ['FR', 'EN'] }
  },

  computed: {
    locale () {
      return this.$i18n.locale.toUpperCase();
    }
  },

  methods: {
    flagFromCountryIso(countryIso) {
      if (countryIso === 'EN') {
        return 'GB';
      }
      if (countryIso === 'GP' || countryIso === 'RE') {
        return 'FR';
      }
      return countryIso;
    },

    setLocale (countryCode) {
      this.$i18n.locale = countryCode.toLowerCase();
      localStorage.setItem("raisonSelectedLanguage", countryCode.toLowerCase());
    }
  }
}
</script>
